export var validateState = function validateState(expectedStates, currentState) {
  if (!expectedStates.includes(currentState)) {
    throw new Error("Expected the state to be ".concat(expectedStates.map(function (expectedState) {
      return "\"".concat(expectedState, "\"");
    }).join(' or '), " but it was \"").concat(currentState, "\"."));
  }
};